import React, { StrictMode,Suspense } from 'react';

import { BrowserRouter} from 'react-router-dom';
import { UserDataContext } from './Context/UserContext';

import * as ReactDOM from 'react-dom/client';
import { ChakraProvider} from '@chakra-ui/react';
import Loading from './Components/Loading';
import theme from './styles/theme';
import './Services/Api/authInterceptor';
// import Footer from './Components/Footer';
import Header from './Components/Header';
import BtnAdm from './Components/BtnAdm';

const Router = React.lazy(() => import('./Router'))
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  // <StrictMode>
    <ChakraProvider theme={theme}>
      <Suspense fallback={<Loading />}>
       <BrowserRouter>
       <UserDataContext>
        <Header />
        <Router />
        {/* <Footer /> */}
        </UserDataContext>
       </BrowserRouter>
      </Suspense>
    </ChakraProvider>
  // </StrictMode>
);

